import React from 'react'

function TextareaInput({ defaultText = '' }) {
    return (
        <div className="mt-1">
          <h1 className="py-4 block text-md font-medium text-gray-700">1) Texte</h1>
          <textarea
            rows={5}
            name="mytext"
            id="mytext"
            className="block p-2.5 w-10/12 rounded-md border border-gray-300 shadow-sm sm:text-md focus:outline-none"
            defaultValue={defaultText}
            placeholder="Tapez ou collez le texte ici"
          />
        </div>
    )
  }

  export  { TextareaInput };
